<template>
    <div>
        <div class="my-2">
            <app-general-figures />
        </div>
        <hr />
        <div class="my-2">
            <app-general-charts />
        </div>
    </div>
</template>
<script>
import GeneralFigures from './GeneralFigures/GeneralFigures';
import GeneralCharts from './GeneralCharts/GeneralCharts';
export default {
    components: {
        appGeneralFigures: GeneralFigures,
        appGeneralCharts: GeneralCharts
    }
}
</script>